import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

// Routes come back one at a time as views are migrated from main.
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'ami*té — Clothing' },
  },
  {
    path: '/produkt/:slug',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: 'Über uns — ami*té' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: 'Kontakt — ami*té' },
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../views/Impressum.vue'),
    meta: { title: 'Impressum — ami*té' },
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: () => import('../views/Datenschutz.vue'),
    meta: { title: 'Datenschutz — ami*té' },
  },
  {
    path: '/agb',
    name: 'AGB',
    component: () => import('../views/AGB.vue'),
    meta: { title: 'AGB — ami*té' },
  },
  {
    path: '/widerrufsrecht',
    name: 'Widerrufsrecht',
    component: () => import('../views/Widerrufsrecht.vue'),
    meta: { title: 'Widerrufsrecht — ami*té' },
  },
  {
    path: '/versand',
    name: 'Versand',
    component: () => import('../views/Versand.vue'),
    meta: { title: 'Versand — ami*té' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
